import { Siren } from "lucide-react";
import { useContactSettings } from "@/hooks/useContactSettings";

export function EmergencyBar({ phone: phoneProp }: { phone?: string }) {
  const { settings } = useContactSettings();
  const p = phoneProp || settings?.emergency_phone || "";
  const clean = p?.replace(/[\s\-\(\)]+/g, "");
  return (
    <a
      href={`tel:${clean}`}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full bg-emergency px-5 py-3 text-emergency-foreground shadow-elevated transition-transform hover:scale-105"
      aria-label={`Emergency: call ${p}`}
    >
      <span className="relative flex h-3 w-3">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-60" />
        <span className="relative inline-flex h-3 w-3 rounded-full bg-white" />
      </span>
      <Siren className="h-5 w-5" />
      <span className="text-sm font-semibold">Emergency · {p}</span>
    </a>
  );
}
